import { AfterViewChecked, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ClaimService } from '@core/services/claim.service';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { LoadingService } from '@core/services/loading.service';
import { LocaleService } from '@core/services/locale.service';
import { UserService } from '@core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Claim } from '@shared/models/claim';
import { ClaimStates } from '@shared/models/codebooks/claim-state';
import { Correspondence } from '@shared/models/correspondence';

@Component({
    selector: 'app-claims',
    templateUrl: './claims.component.html',
    styleUrls: ['./claims.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClaimsComponent implements OnInit {
  readonly claimStates: ClaimStates;
  public claims: Claim[];
  public claimsPast: Claim[];
  public documents: Correspondence[];
  private firstload = true;


  public selectedIndex = 0;

  constructor(
    private userService: UserService,
    private localeService: LocaleService,
    private claimService: ClaimService,
    private commonService: CommonService,
    private dataService: DataService,
    private translateService: TranslateService,
    protected loadingService: LoadingService
  ) {
    this.claimStates = this.dataService.claimStates;


    /*
ak claimClassId <> null a zároveň claimClassId existuje v číselníku typov škôd na záložke 'clm_class_mapping':
     -> claimClassId premapovať na popis claim_class_desc (príslušnej jazykovej mutácie) z číselníka typov škôd
ak claimClassId null alebo claimClassId neexistuje v číselníku typov škôd na záložke 'clm_class_mapping':
     -> lobId premapovať na popis clm_LoB_desc (príslušnej jazykovej mutácie) z číselníka Allianz konto škodových LoBov - viď záložka 'clm_LoB_mapping'
     */
    this.claimService.getClaimsActive().subscribe(res => {
      this.claims = res;
      let tmp = []
      for (let i = 0; i < this.claims.length; i++) {
        if (this.claims[i] == null) {
          continue;
        }

        if (this.claims[i].claimClassId != null) {
          this.translateService.get('claim.class-mapping').subscribe(trans => {
            if (trans[this.claims[i].claimClassId] != undefined) {
              this.claims[i].claimClassLabel = 'claim.class-mapping.' + this.claims[i].claimClassId;
            } else {
              this.claims[i].claimClassLabel = 'claim.lob-mapping.' + this.claims[i].lobId;
            }
          });
        } else {
          this.claims[i].claimClassLabel = 'claim.lob-mapping.' + this.claims[i].lobId;
        }

        tmp.push(this.claims[i]);
      }

      this.claims = tmp;
    });
  }

  /*click(index){
    this.selectedIndex = index;
  }*/

  ngOnInit(): void {
    this.userService.getLoggedUser().subscribe(() => {
      this.localeService.activeLanguage.subscribe(language => {
        if (!this.firstload) {
          // reload bc translations documents
          window.location.reload();
        }

        this.firstload = false;
      });
    });
  }

  tabChanged(index): void {
    this.selectedIndex = index;
    if (index === 1 && !this.claimsPast) {
      this.claimService.getClaimsPast().subscribe(res => {
        this.claimsPast = res;
        let tmp = [];

        for (let i = 0; i < this.claimsPast.length; i++) {
          if (this.claimsPast[i] == null) {
            continue;
          }

          /*if (this.claimsPast[i].claimClassId == null) {
            this.claimsPast[i].claimClassLabel = 'claim.lob-mapping.' + this.claimsPast[i].lobId;
          }*/

          if (this.claimsPast[i].claimClassId != null) {
            this.translateService.get('claim.class-mapping').subscribe(trans => {
              if (trans[this.claimsPast[i].claimClassId] != undefined) {
                this.claimsPast[i].claimClassLabel = 'claim.class-mapping.' + this.claimsPast[i].claimClassId;
              } else {
                this.claimsPast[i].claimClassLabel = 'claim.lob-mapping.' + this.claimsPast[i].lobId;
              }
            });
          } else {
            this.claimsPast[i].claimClassLabel = 'claim.lob-mapping.' + this.claimsPast[i].lobId;
          }

          tmp.push(this.claimsPast[i]);
        }

        this.claimsPast = tmp;
      });
    }
  }
}
